import React, {useState, Fragment, useEffect} from "react";
import {Upload, Modal, message, Icon} from "antd";
import OSS from 'ali-oss';

const UNIT_MB = 1024 * 1024 * 10; //1M   10M

const MEDIA_SETTINGS = {
  "image/*": {
    tag: "img",
    fileLimit: UNIT_MB,
    title: "图片"
  },
  "audio/*": {
    tag: "audio",
    fileLimit: 5 * UNIT_MB,
    title: "音频"
  },
  "video/*": {
    tag: "video",
    fileLimit: 100 * UNIT_MB,
    title: "视频"
  }
};

/**
 * @param accept 支持图片/音频/视频
 * @param multiple
 */
const FileUpload = ({
  accept = "image/*",
  multiple = false,
  name = "file",
  value = [],
  onChange,
  maxCount = 1,
  OSSConfig = {}
}) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState('');
  const mediaType = MEDIA_SETTINGS[accept];
  const tagName = mediaType.tag;
  const title = mediaType.title;
  const client = new OSS(OSSConfig);

  useEffect(() => {
    console.log(value)
  }, [value])

  // 预览
  const handlePreview = ({url}) => {
    setPreviewFileUrl(url);
    setPreviewVisible(true);
  };

  const handleRemove = (file) => {
    const index = value.findIndex(_ => _.uid === file.uid);
    // const index = value.findIndex(_ => _.fileId === file.fileId || _.uid === file.uid);

    if (index < 0) return;

    const newValue = [...value];
    newValue.splice(index, 1);
    onChange(newValue);
  };

  const uploadPath = (path, file) => {
    console.log(path, file)
    return `${path}/${file.name.split('.')[0]}-${file.uid}.${file.type.split('/')[1]}`;
  };

  const UploadToOss = (self, path, file) => {
    const url = uploadPath(path, file);
    console.log(url)
    return new Promise((resolve, reject) => {
      client
        .multipartUpload(url, file)
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  const handleBeforeUpload = (file) => {
    if (file.size > mediaType.fileLimit) {
      message.info(`选择的${title}文件尺寸过大`);
      return;
    }

    console.log(file)
    let reader = new FileReader();
    const folder = '';

    reader.readAsDataURL(file);
    console.log(file)
    reader.onloadend = () => {
      UploadToOss(this, folder, file)
        .then(data => {
          return data;
        })
        .then(data => {
          let src = data.res.requestUrls[0];
          console.log(data)
          src = src.indexOf('?') > -1 ? src.substr(0, src.indexOf('?')) : src;
          const uid = multiple ? value.length + 1 : 1;

          const newFile = {
            type: file.type,
            name: file.name,
            uid,
            url: src
          };

          if (multiple) {
            value = [...value, newFile];
            if(maxCount){
              if(value.length > maxCount){
                value = value.slice(0,maxCount);
              }
            }
          } else {
            value = [newFile];
          }

          onChange(value);
        });
    };

    return false;
  };

  let modal = null;

  if (previewVisible) {
    modal = (
      <Modal visible={previewVisible} width='auto' centered={true} footer={null} onCancel={() => setPreviewVisible(false)}>
        {React.createElement(tagName, {src: previewFileUrl, className: `${tagName}-preview`})}
      </Modal>
    );
  }

  return (
    <Fragment>
      <Upload
        listType="picture-card"
        fileList={value}
        multiple={multiple}
        accept={accept}
        name={name}
        onPreview={handlePreview}
        onRemove={handleRemove}
        beforeUpload={handleBeforeUpload}
      >
        {value.length >= maxCount ? null : (
          <div>
            <Icon type="plus" />
          </div>
        )}
      </Upload>
      {modal}
    </Fragment>
  );
};

export default FileUpload;
